import React, { useEffect, useState } from "react";
import {  Col,  Row,  Form,  Input,  Modal,  Select, theme,} from "antd";
import { URL_SALE } from "../../constants/urls";
import { PATCH, POST } from "../../frameworks/HttpClient";
import useDropdownItem from "../../common/useDropdownItem";
import { DATE_FORMAT, PRODUCT_TYPE } from "../../constants/string";
import ErrorMessages from "../../common/ErrorMessages";
import CustomDatePicker from "../../common/CustomDatePicker";
import _ from "lodash";

const { TextArea } = Input;

export default function AddSaleSkimModal(props) {
  const { open, onClose, target, onUpdate } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = useState(null);
  const [debouncedBuyer, setDebouncedBuyer] = React.useState('');
  const [debouncedPacking, setDebouncedPacking] = React.useState('');
  const [debouncedProduct, setDebouncedProduct] = React.useState('');

  const buyerOptions = useDropdownItem({
    manual: true,
    url: URL_SALE.SALE_BUYER,
    label: "name",
    value: "id",
    pagination: true,
    params: { page_size: 999, name : debouncedBuyer},
  });
  const debounceBuyer = React.useCallback(_.debounce((_searchVal) => { setDebouncedBuyer(_searchVal) }, 800), []);

  const packingOptions = useDropdownItem({
    manual: true,
    url: URL_SALE.SALE_PACKING,
    label: "name",
    value: "id",
    pagination: true,
    params: { page_size: 999, name: debouncedPacking},
  });
  const debouncePacking = React.useCallback(_.debounce((_searchVal) => { setDebouncedPacking(_searchVal) }, 800), []);

  const productOptions = useDropdownItem({
    manual: true,
    url: URL_SALE.SALE_PRODUCT,
    label_renderer : (e) => e.short_name ? `${e.name} - ${e.short_name}` : `${e.name}`, 
    value: "id",
    pagination: true,
    params: { page_size: 999, type : PRODUCT_TYPE.SKIM, name: debouncedProduct},
  });
  const debounceProduct = React.useCallback(_.debounce((_searchVal) => { setDebouncedProduct(_searchVal) }, 800), []);
  const {
    token: { colorSuccess, colorWarning },
  } = theme.useToken();

  useEffect(() => {
    if (target) {
      form.setFieldsValue({...target,
        product : {label : target.product_name, value : target.product}
      });
    } else {
      form.resetFields();
    }
  }, [open]);

  const handleOK = async () => {
    setLoading(true)
    setErrorMessages(null);
    try {
      const data = await form.validateFields();
      if(data['product'].label){
        data['product'] = data['product'].value
      }
      if (target?.id) {
        await PATCH(`${URL_SALE.SKIM_SALE_ORDER}${target.id}/`, data);
      } else {
        await POST(URL_SALE.SKIM_SALE_ORDER, data);
      }
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false)
    }
  };

  React.useEffect(() => {
    if(open){
      buyerOptions.fetchOptions();
      packingOptions.fetchOptions();
      productOptions.fetchOptions();
      // buyerOptions.addOption({name : target.name, id: target.buyer, value :target.buyer});
      // packingOptions.addOption({name : target.packing_name, id: target.packing, value :target.packing});
      // productOptions.addOption({name : target.product_name, id: target.product, value :target.product});
    }
  },[open])

  React.useEffect(() => {
    if(open){
      packingOptions.fetchOptions();
    }
  },[debouncedPacking])

  React.useEffect(() => {
    if(open){
      buyerOptions.fetchOptions();
    }
  },[debouncedBuyer])

  React.useEffect(() => {
    if(open){
      productOptions.fetchOptions();
    }
  },[debouncedProduct])



  return (
    <Modal
      open={open}
      onCancel={onClose}
      okText={target?.id ? "แก้ไข" : "เพิ่ม"}
      cancelText={"ยกเลิก"}
      title={target?.id ? "แก้ไขรายการขายสกิม" : "เพิ่มรายการขายสกิม"}
      width={700}
      onOk={handleOK}
      destroyOnClose
      okButtonProps={{
        style: { backgroundColor: target?.id ? colorWarning : colorSuccess },
        loading
      }}    
    >
      <ErrorMessages message={errorMessages} />
      <Form
        form={form}
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 18 }}
        style={{ maxWidth: 800, margin: "auto" }}
        layout="vertical"
      >
        <Col>
          <Form.Item
            name="buyer"
            label={"ลูกค้า"}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
          >
            <Select 
              showSearch
              options={buyerOptions.options} 
              placeholder={"ลูกค้า"}
              onSearch={debounceBuyer}
              filterOption={false}
            />
          </Form.Item>
        </Col>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="สินค้าที่ต้องการ"
              name="product"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
            >
              <Select
                showSearch
                autoComplete="off"
                options={productOptions.options}
                filterOption={false}
                onSearch={debounceProduct}
                style={{ width: "100%" }}
                placeholder={"สินค้าที่ต้องการ"}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="เลขที่ใบสั่งซื้อ"
              name="order_no"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
            >
              <Input style={{ width: "100%" }} placeholder={"เลขใบที่สั่งซื้อ"}/>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={8}>
            <CustomDatePicker
              label="วันที่สั่งซื้อ"
              name="order_date"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
              format={DATE_FORMAT} placeholder={"วันที่สั่งซื้อ"}
            />
          </Col>
          <Col span={8}>
            <Form.Item
              label="ปริมาณที่ต้องการ (น้ำหนัก)"
              name="require_weight"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
            >
              <Input style={{ width: "100%" }} placeholder={"ปริมาณที่ต้องการ"}/>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="ปริมาณที่ต้องการ (ก้อน)"
              name="require_amount"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
            >
              <Input style={{ width: "100%" }} placeholder={"ปริมาณที่ต้องการ"}/>
            </Form.Item>
          </Col>
          </Row>
          
          <Row gutter={12}>
          <Col span={8}>
            <Form.Item
              label="Packing"
              name="packing"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
            >
              <Select
                showSearch
                autoComplete="off"
                options={packingOptions.options}
                onSearch={debouncePacking}
                filterOption={false}
                style={{ width: "100%" }}
                placeholder={"Packing"}
              />
            </Form.Item>
          </Col>
        
          <Col span={8}>
            <Form.Item
              label="Shipment"
              name="shipment"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <Input style={{ width: "100%" }} placeholder={"Shipment"}/>
            </Form.Item>
          </Col>
          <Col span={8}>
            <CustomDatePicker
              label="เดือนที่ส่งสินค้า"
              name="shipment_date"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            />
          </Col>
        </Row>
        <Form.Item
          label="ข้อความเพิ่มเติม"
          name="note"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
        >
          <TextArea rows={4} style={{ width: "100%" }} placeholder={"ข้อความเพิ่มเติม"}/>
        </Form.Item>
      </Form>
    </Modal>
  );
}
